import { createApi } from '@/api/modules/utils'

const baseUrl = '/brand'
const api = createApi(baseUrl)

// 品牌管理
export const brandApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get')
}
